import { render, staticRenderFns } from "./CompCreateUser.vue?vue&type=template&id=32b1ab0d&scoped=true"
import script from "./CompCreateUser.vue?vue&type=script&lang=js"
export * from "./CompCreateUser.vue?vue&type=script&lang=js"
import style0 from "./CompCreateUser.vue?vue&type=style&index=0&id=32b1ab0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1ab0d",
  null
  
)

export default component.exports